import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PageContentContainer from "../../Container/PageContentContainer";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import { useCase } from "../../../provider/CaseProvider";
import { fetchResource, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import ExecutionJobDetailsCard from "../../Executionjob/ExecutionJobDetailsCard.tsx";
import ExecutionJobStepsTable from "../../Executionjob/ExecutionJobStepsTable.tsx";
import { useRegisterRefetchPageData } from "../../../hooks/useRegisterRefetchPageData.ts";
import { ExecutionJob } from "../../../types/ExecutionJob/ExecutionJob.ts";

const CaseExecutionJobDetailsPage = () => {
  const { executionJobId } = useParams();
  const { product, refreshCase } = useCase();
  const queryClient = useQueryClient();
  const executionJobIdAsNumber = parseInt(executionJobId || "-1");

  const { data: executionJob, isLoading } = useQuery<ExecutionJob>({
    queryKey: queryKeys.item("execution_jobs", executionJobIdAsNumber),
    queryFn: () => fetchResource("execution_jobs", executionJobIdAsNumber),
  });

  const refreshPage = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.item("execution_jobs", executionJobIdAsNumber),
    });
    refreshCase();
  };

  useRegisterRefetchPageData(refreshPage);

  if (!executionJobId) {
    return null;
  }

  if (!product || isLoading || !executionJob) {
    return <LegalBirdPageLoading />;
  }

  return (
    <PageContentContainer>
      <ProductHeadline title={`Execution Job #${executionJob.id} zu`} product={product} />
      <ExecutionJobDetailsCard executionJob={executionJob} />
      <ExecutionJobStepsTable executionJob={executionJob} />
    </PageContentContainer>
  );
};

export default CaseExecutionJobDetailsPage;
